import { lazy } from 'react';

import { NAVIGATION_PERMISSIONS } from '~/lib/navigationPermissions';

import type { IRemoteDeclaration } from './types';

const remotes: IRemoteDeclaration[] = [
  {
    name: 'wmg-dashboard',
    path: ['*'],
    brands: ['WMG'],
    status: lazy(() =>
      import('~/modules/link-farm/router').then((module) => ({
        default: module.LinkFarmRouter,
      })),
    ),
    root: lazy(() =>
      import('~/modules/link-farm/router').then((module) => ({
        default: module.LinkFarmRouter,
      })),
    ),
    permission: () => true,
  },
  {
    name: 'release-management',
    path: ['release-management/*'],
    brands: ['WMG'],
    status: lazy(() => import('ReleaseManagementApp/Status')),
    root: lazy(() => import('ReleaseManagementApp/App')),
    permission: NAVIGATION_PERMISSIONS.WMG_RELEASE_MANAGEMENT,
    prefix: 'release-management',
  },
  {
    name: 'music-iq',
    path: ['data/music-iq/*'],
    brands: ['WMG'],
    status: lazy(() => import('MusicIqChatbotApp/Status')),
    root: lazy(() => import('MusicIqChatbotApp/App')),
    permission: NAVIGATION_PERMISSIONS.WMG_MUSIC_IQ,
    prefix: 'music-iq',
  },
  {
    isolateStyles: true,
    name: 'aim',
    path: ['aim/*'], // @TODO DSCAIM-54 Remove this once we have a proper path for Aim App in the registry.ts file
    // This is a temporary path we need to test implementation of Aim App
    // Business consider not exposing /aim in the final version, but didn't come up with the name so far
    brands: ['WMG'],
    status: lazy(() => import('AimApp/Status')),
    root: lazy(() => import('AimApp/App')),
    permission: () => true,
    prefix: 'aim',
  },
  {
    isolateStyles: true,
    name: 'video-management',
    path: ['video-management/*'],
    brands: ['ADA', 'WMG'],
    status: lazy(() => import('VideoApp/Status')),
    root: lazy(() => import('VideoApp/App')),
    prefix: 'video-management',
    permission: NAVIGATION_PERMISSIONS.VIDEO_MANAGEMENT,
  },
  {
    isolateStyles: true,
    name: 'coop',
    path: [
      '*',
      'release',
      'my-profile',
      'platform',
      'release-clinic',
      'uploads',
      'redirect',
      'exports',
      'data_exports',
      'data_export',
      'data-exports',
      'data-export',
      'reports',
      'report',
      'my-permissions',
      'preferences',
      'ingestions',
    ],
    brands: ['ADA'],
    status: lazy(() => import('CoopApp/Status')),
    root: lazy(() => import('CoopApp/App')),
    permission: () => true,
  },
  // NOTE: This is a placeholder so that federated front ends can test using the
  //       WMG1 shell without WMG1 having a remote defined for the new app yet.
  //       Allows for debugging the new app and then as a final step, the new
  //       remote can be added to WMG1. Nothing in WMG1 will ever load for this route.
  {
    name: 'remote-placeholder',
    path: ['remote-placeholder/*'],
    brands: ['WMG'],
    status: () => null,
    root: () => null,
    permission: () => true,
    prefix: 'remote-placeholder',
  },
];

export { remotes };

/**
 * Standalone remote components that don't follow the standard registry pattern
 * (no Status/App pair) but still need to be in this file so the federation
 * plugin discovers the import during the main-chunk build phase.
 */
export const RemoteAIPermissions = lazy(
  () => import('AIConsentApp/ArtistAIPermissions'),
);
